const SCROLL_THRESHOLD = 20

export const getIsScrollAtBottom = (containerRef: HTMLElement | null) =>
  containerRef &&
  containerRef.scrollTop + containerRef.clientHeight + SCROLL_THRESHOLD >=
    containerRef.scrollHeight
